module.exports = __webpack_public_path__ + "media/images/pinLeft-80a4070ae1aefdabb03e348194562f06.png";